import React, { useContext, useEffect, useRef, useState } from "react";
import {
  IonItem,
  IonInput,
  IonButton,
  IonContent,
  IonPage,
  IonGrid,
  IonCol,
  IonRow,
  IonToolbar,
  IonTitle,
  IonHeader,
  IonModal,
  IonButtons,
  IonLabel,
  IonSpinner,
  IonSegment,
  IonSegmentButton,
  useIonAlert,
  useIonToast,
  IonFooter,
} from "@ionic/react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import { Link, useHistory } from "react-router-dom";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { OverlayEventDetail } from "@ionic/core";
import { NoConnectionMsg } from "../components/NoConnection";
import { ProfileContext } from "../context/ProfileContext";
import packageJson from "../../package.json";
import { fx_FB_AcceptAssociateRequest } from "../functions/Fx_AssociateFunctions";
import { fx_FB_RedeemInviteCode, REDEEM_RESULT } from "../functions/Fx_InviteCodes";
import { processDMMessage } from "../utils/chatUtils";
import { FB_COLLECTION_PATH } from "../functions/postActionTypes";
import { SUPPORT_MONKEY_UID, SUPPORT_MONKEY_ASSOCIATE } from "../constants/supportConstants";

const CreateAccount: React.FC = () => {
  const history = useHistory();
  const [err1, setErr1] = useState(false);
  const [err2, setErr2] = useState(false);
  const [err3, setErr3] = useState(false);
  const [err4, setErr4] = useState(false);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [password2, setPassword2] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [occupation, setOccupation] = React.useState("");
  const [inviteCode, setInviteCode] = React.useState("");
  const [firstNameColor, setFirstNameColor] = React.useState("dark");
  const [lastNameColor, setLastNameColor] = React.useState("dark");
  const [emailColor, setEmailColor] = React.useState("dark");
  const [companyColor, setCompanyColor] = React.useState("dark");
  const [occupationColor, setOccupationColor] = React.useState("dark");
  const [passwordColor, setPasswordColor] = React.useState("dark");
  const [passwordColor2, setPasswordColor2] = React.useState("dark");
  const authEmail = getAuth();
  const [present] = useIonAlert();
  const [presentToast] = useIonToast();
  const [userRole, setUserRole] = useState<"werker" | "scheduler" | null>(null);
  const [err5, setErr5] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [progress, setProgress] = useState(0);
  const { networkConnection } = useContext(ProfileContext);

  const modal = useRef<HTMLIonModalElement>(null);
  const input = useRef<HTMLIonInputElement>(null);

  const passwordRequirements =
    "Guide: Password must be 8 or more characters, contain upper and lower case letters, and a number. ";
  const passwordRequirements2 = "Guide: Passwords must match. ";
  const emailRequirement = "Guide: Please provide a valid email. ";
  const firestoreErrorMessage = "This email is already in use. Click here to reset password via email. ";

  // https://timetoprogram.com/check-password-strength-react/
  const passwordChecker = (passwordValue: string) => {
    const strengthChecks = {
      length: false,
      hasUpperCase: false,
      hasLowerCase: false,
      hasDigit: false,
    };
    strengthChecks.length = passwordValue.length >= 8 ? true : false;
    strengthChecks.hasUpperCase = /[A-Z]+/.test(passwordValue);
    strengthChecks.hasLowerCase = /[a-z]+/.test(passwordValue);
    strengthChecks.hasDigit = /[0-9]+/.test(passwordValue);
    return strengthChecks;
  };

  const runFormControls = async () => {
    let formCheckResults: boolean = true;
    // Form Controls
    if (firstName === "") {
      setFirstNameColor("danger");
      formCheckResults = false;
    }
    if (lastName === "") {
      setLastNameColor("danger");
      formCheckResults = false;
    }
    // eslint-disable-next-line
    let re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(email)) {
    } else {
      setEmailColor("danger");
      formCheckResults = false;
    }
    if (company === "") {
      setCompanyColor("danger");
      formCheckResults = false;
    }
    if (occupation === "") {
      setOccupationColor("danger");
      formCheckResults = false;
    }
    if (userRole === null) {
      setErr5(true);
      formCheckResults = false;
    }
    // Check password requirements
    const passwordTest = passwordChecker(password);
    // console.log(passwordTest);
    if (!passwordTest.length || !passwordTest.hasUpperCase || !passwordTest.hasLowerCase || !passwordTest.hasDigit) {
      setPasswordColor("danger");
      setErr1(true);
      formCheckResults = false;
    }
    if (password !== password2) {
      setPasswordColor("danger");
      setPasswordColor2("danger");
      setErr2(true);
      formCheckResults = false;
    }

    return formCheckResults;
  };

  const handleSubmit = async () => {
    if (isSubmitting) return;
    setErr1(false);
    setErr2(false);
    setErr3(false);
    setErr4(false);
    setErr5(false);
    setFirstNameColor("dark");
    setLastNameColor("dark");
    setEmailColor("dark");
    setPasswordColor("dark");
    setPasswordColor2("dark");
    setCompanyColor("dark");
    setOccupationColor("dark");

    const check = await runFormControls();
    if (!check) return;

    setIsSubmitting(true);
    setProgress(0);
    // Tell Home to suppress WerkerOnboarding while signup is running.
    // Without this, SplashPage's authReady-driven redirect can mount Home
    // in IonRouterOutlet behind us, causing the orientation modal to open
    // as a portal on top of CreateAccount.
    sessionStorage.setItem("signupInProgress", "1");
    try {
      // Create user auth (this also signs them in)
      const res = await createUserWithEmailAndPassword(auth, email, password);
      setProgress(10);

      // create top-level user doc
      await setDoc(doc(db, "users", res.user.uid), {
        uid: res.user.uid,
        firstName,
        lastName,
        email,
        company,
        occupation,
        userBio: "",
        profilePicURL: "../assets/profilePic.png",
        isScheduler: userRole === "scheduler",
        isDeleted: false,
        userLastRoleScheduler: false,
        associates_Associates: ["XXX"], // placeholder associate for new users
      });
      setProgress(25);

      // create associate facing user doc
      await setDoc(doc(db, `users/${res.user.uid}/users_AssociateFacing`, res.user.uid), {
        uid: res.user.uid,
        firstName,
        lastName,
        email,
        company,
        occupation,
        userBio: "Hello!",
        profilePicURL: "../assets/profilePic.png",
        isScheduler: userRole === "scheduler",
        isDeleted: false,
      });
      setProgress(40);

      // create public facing user doc
      await setDoc(doc(db, `users/${res.user.uid}/users_PublicFacing`, res.user.uid), {
        uid: res.user.uid,
        firstName,
        lastName,
        company,
        occupation,
        userBio: "Hello!",
        profilePicURL: "../assets/profilePic.png",
      });
      setProgress(55);

      // userAssociations doc
      await setDoc(doc(db, "userAssociations", res.user.uid), {
        myDoc: `${firstName} ${lastName}`,
      });
      setProgress(65);

      // userSettings doc
      await setDoc(
        doc(db, "userSettings", res.user.uid),
        {
          appVersion: packageJson.version,
          userID: res.user.uid,
          ...(userRole === "scheduler" && { isNewScheduler: true, schedulerSignupTimestamp: Date.now() }),
        },
        { merge: true }
      );
      setProgress(75);

      // Build the new user profile object (same as before)
      const newUserProfile = {
        UserId: res.user.uid,
        FirstName: firstName,
        LastName: lastName,
        ProfilePicURL: "../assets/profilePic.png",
      };

      // Accept Support Monkey as associate AND get the DM chatId
      let chatId: string | undefined;
      try {
        chatId = await fx_FB_AcceptAssociateRequest(
          res.user.uid,
          firstName,
          lastName,
          company,
          "../assets/profilePic.png",
          SUPPORT_MONKEY_UID,
          "WerkApp",
          "Monkeys",
          "WerkApp",
          "https://firebasestorage.googleapis.com/v0/b/werkapp-b5808.appspot.com/o/y4Evz9nRBMTgNp9syD3SRvuBO0u2%2FprofilePic%2F1760484874049.jpeg?alt=media&token=2d4470e1-cd54-4a0e-a20f-040eb26827a3"
        );
      } catch (err) {
        console.error("Failed to auto-associate Support Monkey:", err);
        // Don't fail signup if support association fails
      }
      setProgress(90);

      // Send welcome message(s) into THAT chat
      if (chatId && typeof chatId === "string") {
        try {
          const isSchedulerSignup = userRole === "scheduler";
          const welcomeMessage = isSchedulerSignup
            ? "Welcome to WerkApp! We're so glad you're here. As a scheduler, you'll be able to post jobs, build your crew, and manage your team all in one place. We'll be in touch shortly — but feel free to reach out here anytime!"
            : "Welcome to WerkApp! We're here to help if you have any questions.";

          await processDMMessage({
            chatId,
            message: welcomeMessage,
            profile: newUserProfile,
            myChats: [], // new user
            myAssociates: [SUPPORT_MONKEY_ASSOCIATE],
            associate: SUPPORT_MONKEY_ASSOCIATE,
          });

          // For schedulers, send onboarding resources as separate messages
          if (isSchedulerSignup) {
            const resourceMessages = [
              "Here are some resources to help you hit the ground running:",
              "📱 Onboarding walkthrough:\nhttps://www.youtube.com/shorts/1TKHmtAbBdA",
              "🎬 10-minute overview:\nhttps://www.youtube.com/watch?v=31dD458TGbQ",
              "📺 WerkApp YouTube channel:\nhttps://www.youtube.com/@WerkApp-Content",
              "🌐 Website:\nhttps://werkapp.app/",
            ];

            for (const message of resourceMessages) {
              await processDMMessage({
                chatId,
                message,
                profile: newUserProfile,
                myChats: [],
                myAssociates: [SUPPORT_MONKEY_ASSOCIATE],
                associate: SUPPORT_MONKEY_ASSOCIATE,
              });
            }
          }

          // processDMMessage marks the sender's chat-doc as isRead: true.
          // For the welcome message we want the new user (the "sender" in the
          // call above, since that preserves the push notification to Support
          // Monkey + admin alerts) to instead see this as an unread incoming
          // message so the Monkey FAB badge and Comms footer badge light up.
          // Override just the isRead field on the new user's chat-doc entry.
          try {
            await setDoc(
              doc(db, FB_COLLECTION_PATH.Chats, res.user.uid),
              { [chatId]: { isRead: false } },
              { merge: true }
            );
          } catch (overrideErr) {
            console.error("Failed to mark welcome message as unread:", overrideErr);
            // Don't fail signup if badge bookkeeping fails
          }
        } catch (err) {
          console.error("Failed to send welcome message:", err);
          // Don't fail signup if welcome message fails
        }
      }
      setProgress(100);

      // Optional: redeem an invite code if the new Werker entered one.
      const trimmedInviteCode = inviteCode.trim();
      if (trimmedInviteCode) {
        try {
          const outcome = await fx_FB_RedeemInviteCode(
            res.user.uid,
            firstName,
            lastName,
            company,
            "../assets/profilePic.png",
            trimmedInviteCode
          );
          if (outcome.result === REDEEM_RESULT.Success || outcome.result === REDEEM_RESULT.AlreadyAssociate) {
            presentToast({
              message: `You've joined ${outcome.schedulerFirstName ?? ""} ${outcome.schedulerLastName ?? ""}'s group.`
                .replace(/\s+/g, " ")
                .trim(),
              duration: 3000,
              position: "top",
              color: "success",
            });
          } else if (outcome.result === REDEEM_RESULT.SelfCode) {
            presentToast({
              message: "You can't redeem your own invite code.",
              duration: 3000,
              position: "top",
              color: "warning",
            });
          } else {
            presentToast({
              message: "Invite code not recognized. You can add it later in Edit Profile.",
              duration: 3500,
              position: "top",
              color: "warning",
            });
          }
        } catch (err) {
          console.error("Invite code redemption failed:", err);
          presentToast({
            message: "Couldn't apply your invite code. You can add it later in Edit Profile.",
            duration: 3500,
            position: "top",
            color: "warning",
          });
        }
      }

      // Signup complete: clear the suppression flag so Home can fire
      // WerkerOnboarding once it mounts after the reload.
      sessionStorage.removeItem("signupInProgress");
      setIsSubmitting(false);
      // Hard navigation with REPLACE: forces a full reload AND overwrites
      // the /createAccount history entry. This destroys Ionic's
      // IonRouterOutlet stack and leaves no /createAccount entry for the
      // WerkerOnboarding modal's auto-dismiss history.go(-1) to walk back to.
      // Firebase auth persists via localStorage so the user stays signed in.
      window.location.replace("/Home");
    } catch (error: any) {
      // console.log(error?.code, error);
      sessionStorage.removeItem("signupInProgress");

      if (error?.code === "auth/email-already-in-use") {
        setErr4(true); // show reset password prompt
        setIsSubmitting(false);
        setProgress(0);
        return;
      }

      await present({
        header: "Couldn't create account",
        message: error?.message || "Unknown error",
        buttons: ["OK"],
      });
      setIsSubmitting(false);
      setProgress(0);
    }
  };

  const cancelRegistration = () => {
    return <Link to="/login"></Link>;
  };

  const handleResetPassword = (emailToSend: string) => {
    // console.log("reset password, ", emailToSend);

    sendPasswordResetEmail(authEmail, emailToSend)
      .then(() => {
        // password reset email sent!
        present({
          header: "Reset email has been sent. (May need to check your spam folder.)",
          buttons: ["Ok"],
        });
      })
      .then(() => {
        history.push("/Login");
      })
      .catch((_error) => {
        // console.log(error);
        present({
          header: "Reset email was been sent.",
          buttons: ["Ok"],
        });
      });
  };

  function confirm() {
    modal.current?.dismiss(input.current?.value, "confirm");
  }

  function onWillDismiss(ev: CustomEvent<OverlayEventDetail>) {
    if (ev.detail.role === "confirm") {
      // console.log("reset submitted");
      handleResetPassword(`${ev.detail.data}`);
    }
  }

  const CreateAcctHeader: React.FC = () => {
    return (
      <React.Fragment>
        {networkConnection === false && <NoConnectionMsg />}
        <IonHeader>
          <IonToolbar color="warning">
            <IonTitle className="title2">Create Account</IonTitle>
          </IonToolbar>
        </IonHeader>
      </React.Fragment>
    );
  };

  const CreateAcctPasswordRecovery: React.FC = () => {
    return (
      <React.Fragment>
        {err4 && (
          <IonRow>
            <IonCol>
              <IonButton id="open-modal" fill="clear">
                <IonLabel text-wrap>{firestoreErrorMessage}</IonLabel>
              </IonButton>
              <IonModal ref={modal} trigger="open-modal" onWillDismiss={(ev) => onWillDismiss(ev)}>
                <IonHeader>
                  <IonToolbar>
                    <IonButtons slot="start">
                      <IonButton onClick={() => modal.current?.dismiss()}>Cancel</IonButton>
                    </IonButtons>
                    <IonTitle>Password Recovery</IonTitle>
                    <IonButtons slot="end">
                      <IonButton strong={true} onClick={() => confirm()}>
                        Submit
                      </IonButton>
                    </IonButtons>
                  </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                  <IonItem>
                    <IonLabel position="stacked">Enter your email</IonLabel>
                    <IonInput ref={input} type="text" placeholder="Your email" />
                  </IonItem>
                </IonContent>
              </IonModal>
            </IonCol>
          </IonRow>
        )}
      </React.Fragment>
    );
  };

  useEffect(() => {
    if (password.length > 0) {
      const passwordTest = passwordChecker(password);
      if (!passwordTest.length || !passwordTest.hasUpperCase || !passwordTest.hasLowerCase || !passwordTest.hasDigit) {
        setErr1(true);
      } else {
        setErr1(false);
      }
    } else {
      setErr1(false);
    }
  }, [password]);

  useEffect(() => {
    if (password2.length > 0) {
      if (password === password2) {
        setErr2(false);
      } else {
        setErr2(true);
      }
    } else {
      setErr2(false);
    }
  }, [password2, password]);

  useEffect(() => {
    if (email.length > 0) {
      // eslint-disable-next-line
      let re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(email)) {
        setErr3(false);
      } else {
        setErr3(true);
      }
    } else {
      setErr3(false);
    }
  }, [email]);

  return (
    <IonPage>
      <CreateAcctHeader />

      {/* Transparent loading overlay — visible while account creation is in progress */}
      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0, 0, 0, 0.55)",
            color: "#fff",
            gap: 12,
          }}
        >
          <IonSpinner name="crescent" style={{ width: 56, height: 56, color: "#fff" }} />
          <div style={{ fontSize: 16, fontWeight: 500 }}>Setting up your account…</div>
          <div style={{ fontSize: 22, fontWeight: 700 }}>{progress}%</div>
        </div>
      )}

      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <p style={{ margin: "12px 16px 2px", fontWeight: 700, fontSize: "0.95rem" }}>
                How will you be using WerkApp?
              </p>
              <p style={{ margin: "0 16px 6px", fontSize: "0.82rem", color: "var(--ion-color-medium)" }}>
                Werkers pick up shifts. Schedulers post jobs and manage their crew.
              </p>
              {err5 && (
                <p style={{ color: "var(--ion-color-danger)", margin: "0 16px 4px", fontSize: "0.85rem" }}>
                  Please select your role to continue.
                </p>
              )}
              <IonSegment
                value={userRole ?? ""}
                onIonChange={(e: any) => {
                  const val = e.detail.value as "werker" | "scheduler";
                  setUserRole(val);
                  setErr5(false);
                }}
                style={{
                  border: err5 ? "2px solid var(--ion-color-danger)" : "2px solid transparent",
                  borderRadius: "0.5rem",
                  margin: "8px 0",
                }}
              >
                <IonSegmentButton value="werker">
                  <IonLabel>I'm a Werker</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="scheduler">
                  <IonLabel>I'm a Scheduler</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  autoCapitalize="sentences"
                  type="text"
                  name="FirstName"
                  placeholder="First Name"
                  color={firstNameColor}
                  onIonInput={(e: any) => setFirstName(e.target.value)}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  autoCapitalize="sentences"
                  type="text"
                  name="LastName"
                  placeholder="Last Name"
                  color={lastNameColor}
                  onIonChange={(e: any) => setLastName(e.target.value)}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          {err3 && <span>{emailRequirement}</span>}
          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  type="email"
                  name="Email"
                  placeholder="Email"
                  color={emailColor}
                  onIonChange={(e: any) => setEmail(e.target.value)}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          {err1 && <span>{passwordRequirements}</span>}
          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  type="password"
                  name="Password"
                  placeholder="Password"
                  color={passwordColor}
                  onIonChange={(e: any) => setPassword(e.target.value)}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          {err2 && <span>{passwordRequirements2}</span>}
          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  type="password"
                  name="Password2"
                  placeholder="Re-type Password"
                  color={passwordColor2}
                  onIonChange={(e: any) => setPassword2(e.target.value)}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  autoCapitalize="sentences"
                  type="text"
                  name="Company"
                  placeholder="Organization"
                  color={companyColor}
                  onIonChange={(e: any) => setCompany(e.target.value)}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  autoCapitalize="sentences"
                  type="text"
                  name="Occupation"
                  placeholder="Title/Occupation"
                  color={occupationColor}
                  onIonChange={(e: any) => setOccupation(e.target.value)}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol>
              <IonItem>
                <IonInput
                  autoCapitalize="characters"
                  type="text"
                  name="InviteCode"
                  placeholder="Invite Code (optional)"
                  value={inviteCode}
                  onIonChange={(e: any) => setInviteCode((e.target.value ?? "").toString().toUpperCase())}
                  clearInput
                ></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>

          <CreateAcctPasswordRecovery />
        </IonGrid>
      </IonContent>
      <IonFooter>
        <IonButton
          onClick={handleSubmit}
          expand="block"
          fill="solid"
          disabled={isSubmitting}
          style={{
            "--background": "#ffc409",
            "--color": "#000",
            "--border-radius": "0.9rem",
            height: "3.1rem",
            fontSize: "1rem",
            fontWeight: 900,
            marginTop: "0.35rem",
          }}
        >
          Create Account
        </IonButton>

        <IonButton
          onClick={cancelRegistration}
          expand="block"
          fill="clear"
          routerLink="/login"
          style={{
            // "--color": "#555",
            fontWeight: 700,
            marginTop: "0.35rem",
          }}
        >
          Cancel
        </IonButton>
      </IonFooter>
    </IonPage>
  );
};

export default CreateAccount;
